<div class="container-fluid ptp-wrapper">
    <div class="d-flex justify-content-between align-items-center">
        <h3>Scheduled Calls</h3>
        <mat-button-toggle-group [value]="callFilter" (change)="onFilterChange($event)" [disabled]="isLoading">
            <mat-button-toggle value="my">My calls</mat-button-toggle>
            <mat-button-toggle value="all">All calls</mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <div style="height: calc(100% - 140px)">
        <!-- Single state display - handles both loading and empty -->
        <app-state-display
            *ngIf="isLoading || (!isLoading && filteredApplicationCalls.length === 0)"
            [type]="isLoading ? 'loading' : 'empty'"
            loadingMessage="Loading application calls..."
            emptyMessage="No application calls found"
            emptyIcon="assignment">
        </app-state-display>

        <!-- Table content -->
        <app-custom-table
            *ngIf="!isLoading && filteredApplicationCalls.length > 0"
            class="ag-theme-material"
            style="width: 100%; height: 100%"
            [rowData]="filteredApplicationCalls"
            [columnDefs]="columns"
            [animateRows]="true"
            [pagination]="true"
            [hideGlobalFilter]="false"
            [dropdownFilters]="dropdownFilters"
            [paginationPageSize]="20"
            (cellClicked)="onCellClicked($event)">
        </app-custom-table>
    </div>
</div>
